import React from 'react';
import { css } from '@emotion/react';
import { NetworkType } from '../../types/insurance-report-api.types';
import { NetworkFilter } from './network-filter';
import Search from './search';

type FilterAndSearchProps = {
  networkNames: string[];
  filterValue: NetworkType | string;
  handleFilterChange: (value: string) => void;
  onSearchChange: (value: string) => void;
};

export const FiltersAndSearchSection: React.FC<FilterAndSearchProps> = React.memo(
  ({ networkNames, filterValue, handleFilterChange, onSearchChange }) => {
    return (
      <section css={filterAndSearchSectionStyles}>
        <NetworkFilter networkNames={networkNames} filterValue={filterValue} handleFilterChange={handleFilterChange} />
        <div css={searchStyles}>
          <Search onSearchChange={onSearchChange} />
        </div>
      </section>
    );
  }
);

FiltersAndSearchSection.displayName = 'FiltersAndSearchSection';

const filterAndSearchSectionStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const searchStyles = css`
  width: 40% !important;
  div {
    div {
      width: 100% !important;
    }
  }
`;
